import { render, staticRenderFns } from "./ObjectExtras.vue?vue&type=template&id=4c4c5a5a&scoped=true&"
import script from "./ObjectExtras.vue?vue&type=script&lang=js&"
export * from "./ObjectExtras.vue?vue&type=script&lang=js&"
import style0 from "./ObjectExtras.vue?vue&type=style&index=0&id=4c4c5a5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4c5a5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VDivider,VRow,VTab,VTabItem,VTabs,VTabsItems,VTooltip})
